import React from 'react';
import Api from "../../servicios/api";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch, faTimes, faArrowRight, faAngleDoubleLeft, faAngleLeft, faAngleDoubleRight, faAngleRight, faSave } from '@fortawesome/free-solid-svg-icons'
import Swal from 'sweetalert2';

class Insumos extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
            datosCargados: false,
            pagina: [],
            usuarios: [],
            seleccionados: [] // Array para almacenar los insumos seleccionados
        }
    }

    // Manejar selección/deselección de insumos
    toggleSeleccion = (insumo) => {
        this.setState(prevState => {
            const existeIndex = prevState.seleccionados.findIndex(item => item.codigo === insumo.codigo);
            
            if (existeIndex !== -1) {
                // Si ya existe, lo removemos
                const nuevosSeleccionados = [...prevState.seleccionados];
                nuevosSeleccionados.splice(existeIndex, 1);
                return { seleccionados: nuevosSeleccionados };
            } else {
                // Si no existe, lo agregamos con cantidad por defecto 1
                return { 
                    seleccionados: [
                        ...prevState.seleccionados, 
                        { 
                            ...insumo, 
                            cantidad: 1 
                        }
                    ] 
                };
            }
        });
    }

    // Actualizar cantidad de un insumo seleccionado
    actualizarCantidad = (codigo, cantidad) => {
        this.setState(prevState => ({
            seleccionados: prevState.seleccionados.map(item =>
                item.codigo === codigo ? { ...item, cantidad: parseInt(cantidad) || 1 } : item
            )
        }));
    }

    // Verificar si un insumo está seleccionado
    estaSeleccionado = (codigo) => {
        return this.state.seleccionados.some(item => item.codigo === codigo);
    }

    // Registrar todos los insumos seleccionados
    registrarSeleccionados = () => {
        const { seleccionados } = this.state;
        
        if (seleccionados.length === 0) {
            Swal.fire('Advertencia!', 'No hay insumos seleccionados', 'warning');
            return;
        }

        const orden = document.getElementById('ordenint').value;
        const fac = document.getElementById('relacionado').value || '0';
        const gastar_i = 'Si';
        const inv = 1;

        // Validar cantidades
        for (const insumo of seleccionados) {
            if (inv === 0 && insumo.cantidad > insumo.cant_disponible) {
                Swal.fire('Error!', `La cantidad de ${insumo.nombre_insumo} es mayor al stock disponible`, 'error');
                return;
            }
        }

        // Preparar datos para enviar
        const datosEnvio = seleccionados.map(insumo => ({
            orden,
            cod: insumo.codigo,
            stock: insumo.cant_disponible,
            cant: insumo.cantidad,
            inv,
            fac,
            gastar_i
        }));

        Swal.fire({
            title: '¿Registrar insumos?',
            text: `Se registrarán ${seleccionados.length} insumo(s)`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sí, registrar',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                this.enviarInsumos(datosEnvio);
            }
        });
    }

    // Enviar insumos al servidor
    enviarInsumos = (datosEnvio) => {
        Swal.showLoading();
        
        fetch(Api + "Insumos/SaveInsumosAsigMultiple", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ insumos: datosEnvio })
        })
        .then(respuesta => respuesta.json())
        .then((datosRespuesta) => {
            Swal.fire('Éxito!', datosRespuesta.msj, 'success');
            
            // Limpiar selección
            this.setState({ seleccionados: [] });
            
            // Recargar datos si existe la función
            if (this.props && this.props.Cargar && typeof this.props.Cargar === 'function') {
                this.props.Cargar();
            }
        })
        .catch(error => {
            console.error('Error:', error);
            Swal.fire('Error!', 'Ocurrió un error al registrar los insumos', 'error');
        });
    }

    resetForm() {
        document.getElementById('bnombre').value = "";
        document.getElementById('busuario').value = "";
        document.getElementById('bnombre').focus();
        this.BuscarInsumoAdd(1);
    }

    componentDidMount() {
        this.BuscarInsumoAdd(1);
    }

    BuscarInsumoAdd(page) {
        let codins = document.getElementById('buscarinsumoadd').value;
        let bname = document.getElementById('bnombreinsadd').value;
        var empresa = localStorage.getItem('empresa');
        if(codins === '') codins = 0;
        if(bname === '') bname = 0;
        
        fetch(Api + "SearchInsumosEmp/"+empresa+"/"+codins+"/"+bname+"?page="+page)
          .then((respuesta) => respuesta.json())
          .then((datosRespuesta) => {
            this.setState({ 
                datosCargados: true, 
                usuarios: datosRespuesta.data, 
                pagina: datosRespuesta.total, 
                ultimo: datosRespuesta.last_page, 
                actual: datosRespuesta.current_page 
            });
          })
          .catch(console.log);
    }

    render() {
        const { datosCargados, usuarios, pagina, ultimo, actual, seleccionados } = this.state;
        
        if (!datosCargados) {
            var load = 'Cargando datos....';
        } else {
            var load = '';
        }

        return (
            <div className="modal-dialog modal-lg modal-dialog-scrollable">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="nuevaEnfermedad1Label">Insumos</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <div className="card">
                            <div style={{ backgroundImage: 'linear-gradient(#2FB3FB, #003153)', color: '#FFFFFF', borderTopLeftRadius: 5, borderTopRightRadius: 5 }} className="card-header text-center">
                                <h5 style={{ fontSize: 18 }} >Lista de Insumos</h5>
                            </div>
                            <div className='card-body'>
                                {/* Barra de herramientas */}
                                <div className="row mb-3">
                                    <div className="col-xl-5">
                                        <input type="text" id="buscarinsumoadd" name="buscarins" placeholder="Codigo insumo" className="form-control form-control-sm" />
                                    </div>
                                    <div className="col-xl-3">
                                        <input type="text" id="bnombreinsadd" name="bnombreins" placeholder="Descripcion del insumo" className="form-control form-control-sm" />
                                    </div>
                                    <div className="col-xl-4">
                                        <button type="button" className="btn btn-primary btn-sm" onClick={() => this.BuscarInsumoAdd(1)}>
                                            <FontAwesomeIcon icon={faSearch} />&nbsp;&nbsp;Buscar
                                        </button>&nbsp;&nbsp;
                                        <button type="button" className="btn btn-danger btn-sm" onClick={() => this.resetForm()} >
                                            <FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar
                                        </button>
                                    </div>
                                </div>

                                {/* Contador de seleccionados */}
                                {seleccionados.length > 0 && (
                                    <div className="alert alert-info py-2">
                                        <div className="row align-items-center">
                                            <div className="col">
                                                <strong>{seleccionados.length}</strong> insumo(s) seleccionado(s)
                                            </div>
                                            <div className="col text-end">
                                                <button 
                                                    type="button" 
                                                    className="btn btn-success btn-sm"
                                                    onClick={this.registrarSeleccionados}
                                                >
                                                    <FontAwesomeIcon icon={faSave} />&nbsp;&nbsp;
                                                    Registrar Seleccionados
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* Tabla de insumos */}
                                <div className="row">
                                    <table className="table table-hover table-condensed table-sm">
                                        <thead className="thead-inverse">
                                            <tr>
                                                <th>SELECCIÓN</th>
                                                <th>CODIGO</th>
                                                <th>DESCRIPCION</th>
                                                <th>STOCK</th>
                                                <th>CANTIDAD</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {load}
                                            {usuarios.map((itemUsuarios) => {
                                                const estaSeleccionado = this.estaSeleccionado(itemUsuarios.codigo);
                                                const insumoSeleccionado = estaSeleccionado 
                                                    ? this.state.seleccionados.find(item => item.codigo === itemUsuarios.codigo)
                                                    : null;
                                                
                                                return (
                                                    <tr key={itemUsuarios.id} className={estaSeleccionado ? 'table-primary' : ''}>
                                                        <td>
                                                            <input
                                                                type="checkbox"
                                                                checked={estaSeleccionado}
                                                                onChange={() => this.toggleSeleccion(itemUsuarios)}
                                                                className="form-check-input"
                                                            />
                                                        </td>
                                                        <td>{itemUsuarios.codigo}</td>
                                                        <td>{itemUsuarios.nombre_insumo}</td>
                                                        <td>{itemUsuarios.cant_disponible}</td>
                                                        <td>
                                                            {estaSeleccionado ? (
                                                                <input 
                                                                    type="number" 
                                                                    value={insumoSeleccionado?.cantidad || 1}
                                                                    onChange={(e) => this.actualizarCantidad(itemUsuarios.codigo, e.target.value)}
                                                                    className="form-control form-control-sm" 
                                                                    style={{width: "80px"}}
                                                                    min="1"
                                                                    max={itemUsuarios.cant_disponible}
                                                                />
                                                            ) : (
                                                                <span className="text-muted">-</span>
                                                            )}
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>

                                {/* Paginación */}
                                <div className="row">
                                    <div className='col-xs-12'>
                                        <nav aria-label="Page navigation example">
                                            <ul className="pagination">
                                                <li className="page-item">
                                                    <a className="page-link" href="#" onClick={() => this.BuscarInsumoAdd(1)}>
                                                        <FontAwesomeIcon icon={faAngleDoubleLeft} />
                                                    </a>
                                                </li>
                                                <li className="page-item">
                                                    <a className="page-link" href="#" onClick={() => this.BuscarInsumoAdd(actual - 1)}>
                                                        <FontAwesomeIcon icon={faAngleLeft} />
                                                    </a>
                                                </li>
                                                <li className="page-item">
                                                    <a className="page-link" href="#" onClick={() => this.BuscarInsumoAdd(actual)}>
                                                        {actual}
                                                    </a>
                                                </li>
                                                <li className="page-item">
                                                    <a className="page-link" href="#" onClick={() => this.BuscarInsumoAdd(actual + 1)}>
                                                        <FontAwesomeIcon icon={faAngleRight} />
                                                    </a>
                                                </li>
                                                <li className="page-item">
                                                    <a className="page-link" href="#" onClick={() => this.BuscarInsumoAdd(ultimo)}>
                                                        <FontAwesomeIcon icon={faAngleDoubleRight} />
                                                    </a>
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                    <div className="card-footer text-muted">
                                        <b>Pagina</b> <span className="badge bg-primary">{actual}</span> <b>de</b> <span className="badge bg-primary">{ultimo}</span> | <b>Registros</b> <span className="badge bg-success">{pagina}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Insumos;